import { Card, H3, Separator } from '@betterment/samba-react';

import guideIcon from '~/b4b/images/b4b-resources-icon-guide.svg';
import hubIcon from '~/b4b/images/b4b-resources-icon-hub.svg';
import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { ResourceCard } from './ResourceCard';

export const ForPlanSponsors = () => {
  return (
    <Card css={{ p: 'space.300', flex: 1 }}>
      <Card.Header css={{ pb: 'space.300' }}>
        <H3 variant="title200">For plan sponsors</H3>
      </Card.Header>

      <Separator />

      <ResourceCard.Section icon={<img src={hubIcon} alt="" />} label="Educational hubs">
        <ResourceCard.Row to={urlBuilder.getResources()} eventName="ManagingPlanHub" eventModule="ForPlanSponsors">
          <ResourceCard.Row.Title>Managing your 401(k) plan</ResourceCard.Row.Title>
          <ResourceCard.Row.Description>
            Introduction for plan sponsors onboarding to Betterment.
          </ResourceCard.Row.Description>
        </ResourceCard.Row>
        <ResourceCard.Row
          to={urlBuilder.getManageYour401kPlan()}
          eventName="PSGeneralResourcesHub"
          eventModule="ForPlanSponsors"
        >
          <ResourceCard.Row.Title>General resources</ResourceCard.Row.Title>
          <ResourceCard.Row.Description>
            Articles, videos, and FAQs to ensure smooth plan management.
          </ResourceCard.Row.Description>
        </ResourceCard.Row>
      </ResourceCard.Section>

      <Separator />

      <ResourceCard.Section icon={<img src={guideIcon} alt="" />} label="Guides">
        <ResourceCard.Row
          to={urlBuilder.getEmployeeEngagementPlaybook()}
          eventName="PSEngagementGuide"
          eventModule="ForPlanSponsors"
        >
          <ResourceCard.Row.Title>Employee engagement playbook</ResourceCard.Row.Title>
          <ResourceCard.Row.Description>
            Shareable templates and messages to help drive employee engagement.
          </ResourceCard.Row.Description>
        </ResourceCard.Row>
      </ResourceCard.Section>
    </Card>
  );
};
